import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [['V.T.', 'Dance Fitness Instructor | New York, USA', 'The choreography systems completely changed how my students experience movement in class. The combinations are already built — I just teach them.'], ['C.R.', 'Dance Fitness Instructor | Melbourne, Australia', 'The cueing system alone was worth every penny. I walk in with the exact phrases ready and my classes feel more confident and professional.'], ['D.G.', 'Dance Fitness Instructor | Toronto, Canada', 'I used to spend two hours every Sunday planning one class. Now I open the system and I am done in five minutes.'], ['A.M.', 'Dance Fitness Instructor | London, UK', 'The monthly challenges transformed my retention. Students who came once in a while are now showing up every single week.'], ['S.R.', 'Dance Fitness Instructor | Dublin, Ireland', 'The 60-minute templates were a game changer. Every session now has a clear beginning, middle, and end — and my clients notice.']];
export function ExtendedTestimonials() {
  return <section className="bg-cloud px-4 py-20 sm:py-24" data-id="element-62">
      <div className="mx-auto max-w-6xl" data-id="element-63">
        <h2 className="mx-auto mb-12 max-w-3xl text-center font-display text-3xl font-black uppercase text-navy sm:text-5xl" data-id="element-64">
          What instructors are <span className="text-violet" data-id="element-65">saying</span>
        </h2>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-66">
          {testimonials.map(([initials, role, quote], index) => <motion.figure key={initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="relative flex flex-col rounded-2xl border border-line bg-white p-7 shadow-sm" data-id="element-67">
              <QuoteIcon className="absolute right-5 top-5 text-violet/10" size={40} data-id="element-68" />
              <div className="flex gap-1 text-violet" data-id="element-69">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={15} fill="currentColor" data-id="element-70" />)}
              </div>
              <blockquote className="mt-5 flex-1 text-sm italic leading-relaxed text-slate-600" data-id="element-71">
                “{quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3" data-id="element-72">
                <span className="flex size-10 items-center justify-center rounded-full bg-navy text-xs font-bold text-white" data-id="element-73">
                  {initials}
                </span>
                <span className="text-xs text-navy-light" data-id="element-74">{role}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}